import Icon from '../components/Icon.vue'

Icon.register({
  futbol: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM456 256l0-0.3-26.1 22.7-62.7-58.5 16.5-84.4 34.3 3.1c-24.9-34.2-60-60.1-100.7-73.1l13.7 31.9-75 41.5-75-41.5 13.7-31.9c-40.6 13-75.8 38.9-100.7 73.1l34.6-3.1 16.2 84.4-62.7 58.5-26.1-22.7 0 0.3c0 43 13.5 84 38.5 118l7.7-33.9 85.1 10.4 36.3 77.8-29.9 17.8c40.2 13.1 84.3 13.1 124.6 0l-29.9-17.8 36.3-77.8 85.1-10.4 7.7 33.9c25-34 38.5-75 38.5-118zM207.9 325.6l-29.9-91.3 78-56.5 78 56.5-29.6 91.3h-96.5z'
      }
    ]
  }
})
